<div class="bh-workbooks-list" [class.!mt-0]="!title" [class.bh-workbooks-list-bestselling]="bestselling" [class.bh-workbooks-list-featured]="featured" [class.bh-workbooks-list-sidebar]="sidebar">
  <div *ngIf="title" class="bh-workbooks-list-title">
    <h2 *ngIf="!interface.title_text"><a routerLink="/store/" title="You may be interested">You may be interested</a></h2>
    <h2 *ngIf="interface.title_text"><a routerLink="/store/" title="{{interface.title_text}}">{{interface.title_text}}</a></h2>
    <p *ngIf="!bestselling && !featured">Best <strong>{{count}}</strong> workbooks for you</p>
      <div *ngIf="featured && !sidebar" class="bh-workbooks-list-title-tabs">
          <div class="bh-workbooks-list-title-tab" [class.bh-workbooks-list-title-tab-active]="interface._cache.workbooks_tab == 'featured'" (click)="actionUpdateWorkbooks('featured')">Featured</div>
          <div class="bh-workbooks-list-title-tab" [class.bh-workbooks-list-title-tab-active]="interface._cache.workbooks_tab == 'on_sale'" (click)="actionUpdateWorkbooks('on_sale')">On Sale</div>
          <div class="bh-workbooks-list-title-tab" [class.bh-workbooks-list-title-tab-active]="interface._cache.workbooks_tab == 'most_viewed'" (click)="actionUpdateWorkbooks('most_viewed')">Most Viewed</div>
      </div>
  </div>
  <div class="bh-workbooks-list-grid" [class.bh-workbooks-list-grid-sidebar]="sidebar">
    <ng-container *ngFor="let workbook of interface.workbooks | random ; let ci = index">
      <div class="bh-workbook" *ngIf="ci < count">
        <div class="bh-workbook-thumbnail" routerLink="/store/product/{{workbook.slug}}/" itemscope itemtype="http://schema.org/ImageObject">
          <img
            itemprop="contentUrl"
            ngSrc="{{workbook.thumbnail}}"
            alt="{{workbook.title}}"
            title="{{workbook.title}}"
            width="128"
            height="177"
          />
          <meta itemprop="name" content="{{workbook.title}}">
          <span itemprop="author" itemscope itemtype="http://schema.org/Organization">
              <meta itemprop="name" content="ArgoPrep">
            </span>
          <meta itemprop="datePublished" content="2023-10-23">
            <div class="bh-workbook-badge" *ngIf="workbook.badges.best_selling">
                <span>Best</span>
                <img ngSrc="./assets/images/backgrounds/blue_badge.svg" alt="badge" height="48" width="48">
            </div>
            <div class="bh-workbook-badge" *ngIf="workbook.badges.sales">
                <span>SALE</span>
                <img ngSrc="./assets/images/backgrounds/red_badge.svg" alt="badge" height="48" width="48">
            </div>
            <div class="bh-workbook-badge" *ngIf="workbook.badges.hot">
                <span>HOT</span>
                <img ngSrc="./assets/images/backgrounds/yellow_badge.svg" alt="badge" height="48" width="48">
            </div>
        </div>
        <div class="bh-workbook-info">
          <a routerLink="/store/product/{{workbook.slug}}/" title="{{workbook.title}}">
              <span>{{workbook.grade || 'Universal'}}</span>
              <div class="bh-workbook-rating-stars">
                  <ng-container *ngFor="let rating of [].constructor(5); let r = index">
                      <img ngSrc="./assets/images/icons/star-full.svg" alt="star" height="15" width="18"/>
                  </ng-container>
                  <span class="!pt-0.5">({{ workbook.rating || "0" }})</span>
              </div>
              <p>{{workbook.title}}</p>
              <label>{{workbook.variations[0]?.costs?.usd | currency: 'USD':'$' || ''}}</label>
          </a>
        </div>
      </div>
    </ng-container>
  </div>
</div>
